export const GET_MODULE_DATA = 'GET_MODULE_DATA'
export const GET_MODULE_DATA_CLONE = 'GET_MODULE_DATA_CLONE'
export const GET_MODULE_DATA_MENU = 'GET_MODULE_DATA_MENU'
export const GET_MODULE_DATA_MENU_CLONE = 'GET_MODULE_DATA_MENU_CLONE'
export const STORE_SUBMODULE_DATA = 'STORE_SUBMODULE_DATA'
export const STORE_SUBSUBMODULE_DATA = 'STORE_SUBSUBMODULE_DATA'
export const LOADING_SAVE_DATA = 'LOADING_SAVE_DATA'